import React from 'react'
import styled from '@emotion/styled'
import { color_text_default, color_variants_red_2 } from '../../constants/colors'
import { DuplicateSpokenName } from '../../utils/menuSpokenNameDuplicates'

interface DuplicateSpokenNamesWarningProps {
    duplicates: (DuplicateSpokenName & { itemNames?: string[] })[]
}

const joinNames = (names: string[]) => names.length <= 1 ? (names[0] ?? "") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;

export default function DuplicateSpokenNamesWarning(props: DuplicateSpokenNamesWarningProps) {
    if (!props.duplicates?.length) return null;
    return (
        <WarningWrapper>
            <WarningTitle>These options share a "Referred to As" name</WarningTitle>
            <WarningText>
                Callers can't choose between options with the same name, so the assistant may send the wrong one to the POS.
            </WarningText>
            <DuplicateList>
                {props.duplicates.map((duplicate, index) =>
                    <li key={index}>
                        {`${duplicate.groupName}: ${joinNames(duplicate.optionNames)} are ${duplicate.optionNames.length > 2 ? "all" : "both"} "${duplicate.spokenName}"`}
                        {duplicate.itemNames?.length ? ` (${joinNames(duplicate.itemNames)})` : ""}
                    </li>
                )}
            </DuplicateList>
        </WarningWrapper>
    )
}

const WarningWrapper = styled.div`
    background: ${color_variants_red_2};
    border-radius: 8px;
    padding: 12px 16px;
    margin: 16px 0;
    color: ${color_text_default};
    text-align: left;
`;

const WarningTitle = styled.p`
    font-weight: bold;
    margin: 0 0 4px 0;
`;

const WarningText = styled.p`
    margin: 0 0 8px 0;
`;

const DuplicateList = styled.ul`
    margin: 0;
    padding-left: 20px;
`;
